/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Dimension, Variant } from '../../products/storage';
import { DimensionTypes } from '../../products/utils/useVariations';

export const getVariantDimensionByType = (
  variant: Variant | undefined,
  dimensionType: DimensionTypes,
): Dimension | undefined => variant?.dimensions.find((d: Dimension) => d.type === dimensionType);

export const getVariantDimensionByValue = (
  variant: Variant | undefined,
  value: string,
): Dimension | undefined => variant?.dimensions.find((d: Dimension) => d.value === value);
